export const FETCH_ARTICLE_PAGE_VIEW = 'FETCH_ARTICLE_PAGE_VIEW';
export const FETCH_PRODUCTS_PAGE_VIEW = 'FETCH_PRODUCTS_PAGE_VIEW';
export const FETCH_PRODUCTS_CATEGORY_PAGE_VIEW = 'FETCH_PRODUCTS_CATEGORY_PAGE_VIEW';
export const FETCH_TEST_CART = 'FETCH_TEST_CART';

export const FETCH_ARTICLE_PAGE_VIEW_SUCCESS = 'FETCH_ARTICLE_PAGE_VIEW_SUCCESS';
export const FETCH_ARTICLE_PAGE_VIEW_FAIL = 'FETCH_ARTICLE_PAGE_VIEW_FAIL';

// PRODUCT LIST
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAIL = 'FETCH_PRODUCTS_FAIL';

// DETAILED PRODUCT
export const FETCH_PRODUCT = 'FETCH_PRODUCT';
export const FETCH_PRODUCT_SUCCESS = 'FETCH_PRODUCT_SUCCESS';
export const FETCH_PRODUCT_FAIL = 'FETCH_PRODUCT_FAIL';

// SHOPPING CART ACTIONS
export const FETCH_CART = 'FETCH_CART';
export const FETCH_CART_SUCCESS = 'FETCH_CART_SUCCESS';
export const FETCH_CART_FAIL = 'FETCH_CART_FAIL';

export const ADD_PRODUCT_TO_CART = 'ADD_PRODUCT_TO_CART';
export const ADD_PRODUCT_TO_CART_SUCCESS = 'ADD_PRODUCT_TO_CART_SUCCESS';
export const ADD_PRODUCT_TO_CART_FAIL = 'ADD_PRODUCT_TO_CART_FAIL';

export const REMOVE_PRODUCT_FROM_CART = 'REMOVE_PRODUCT_FROM_CARTTE_CART_ROW';
export const REMOVE_PRODUCT_FROM_CART_SUCCESS = 'REMOVE_PRODUCT_FROM_CARTTE_CART_ROW_SUCCESS';
export const REMOVE_PRODUCT_FROM_CART_FAIL = 'REMOVE_PRODUCT_FROM_CARTTE_CART_ROW_FAIL';

export const DELETE_CART_ROW = 'DELETE_CART_ROW';
export const DELETE_CART_ROW_SUCCESS = 'DELETE_CART_ROW_SUCCESS';
export const DELETE_CART_ROW_FAIL = 'DELETE_CART_ROW_FAIL';

// INSTAGRAM POSTS
export const FETCH_INSTAGRAM_POSTS = 'FETCH_INSTAGRAM_POSTS';
export const FETCH_INSTAGRAM_POSTS_SUCCESS = 'FETCH_INSTAGRAM_POSTS_SUCCESS';
export const FETCH_INSTAGRAM_POSTS_FAIL = 'FETCH_INSTAGRAM_POSTS_FAIL';

export const SET_VIEWSTATE = 'SET_VIEWSTATE';
export const REMOVE_VIEWSTATE = 'REMOVE_VIEWSTATE';

export const FETCH_GLOBAL_SEARCH = 'FETCH_GLOBAL_SEARCH';
export const FETCH_GLOBAL_SEARCH_SUCCESS = 'FETCH_GLOBAL_SEARCH_SUCCESS';
export const FETCH_GLOBAL_SEARCH_FAIL = 'FETCH_GLOBAL_SEARCH_FAIL';
export const REMOVE_GLOBAL_SEARCH = 'REMOVE_GLOBAL_SEARCH';

export const FETCH_QUICK_SEARCH = 'FETCH_QUICK_SEARCH';
export const FETCH_QUICK_SEARCH_SUCCESS = 'FETCH_QUICK_SEARCH_SUCCESS';
export const FETCH_QUICK_SEARCH_FAIL = 'FETCH_QUICK_SEARCH_FAIL';
export const REMOVE_QUICK_SEARCH = 'REMOVE_QUICK_SEARCH';

export const FETCH_BRAND_DATA = 'FETCH_BRAND_DATA';
export const FETCH_BRAND_DATA_SUCCESS = 'FETCH_BRAND_DATA_SUCCESS';
export const FETCH_BRAND_DATA_FAIL = 'FETCH_BRAND_DATA_FAIL';

export const FETCH_DESIGNERS_DATA = 'FETCH_DESIGNERS_DATA';
export const FETCH_DESIGNERS_DATA_SUCCESS = 'FETCH_DESIGNERS_DATA_SUCCESS';
export const FETCH_DESIGNERS_DATA_FAIL = 'FETCH_DESIGNERS_DATA_FAIL';

export const FETCH_CATEGORY_META_DATA = 'FETCH_CATEGORY_META_DATA';
export const FETCH_CATEGORY_META_DATA_SUCCESS = 'FETCH_CATEGORY_META_DATA_SUCCESS';
export const FETCH_CATEGORY_META_DATA_FAIL = 'FETCH_CATEGORY_META_DATA_FAIL';

// CHECKOUT ACTIONS
export const FETCH_DELIVERY_METHODS = 'FETCH_DELIVERY_METHODS';
export const FETCH_DELIVERY_METHODS_SUCCESS = 'FETCH_DELIVERY_METHODS_SUCCESS';
export const FETCH_DELIVERY_METHODS_FAIL = 'FETCH_DELIVERY_METHODS_FAIL';


export const FETCH_CAMPAIGN_PRODUCTS = 'FETCH_CAMPAIGN_PRODUCTS';
export const FETCH_CAMPAIGN_PRODUCTS_SUCCESS = 'FETCH_CAMPAIGN_PRODUCTS_SUCCESS';
export const FETCH_CAMPAIGN_PRODUCTS_FAIL = 'FETCH_CAMPAIGN_PRODUCTS_FAIL';





// WEBPACK FOOTER //
// ./src/actions/actionTypes.js